import NotificacionService from 'src/modules/notificacion/notificacionService';
import selectors from 'src/modules/notificacion/list/notificacionListSelectors';
import { i18n } from 'src/i18n';
import exporterFields from 'src/modules/notificacion/list/notificacionListExporterFields';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';

const prefix = 'NOTIFICACION_LIST';

const notificacionListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,
  TOGGLE_ONE_SELECTED: `${prefix}_TOGGLE_ONE_SELECTED`,
  TOGGLE_ALL_SELECTED: `${prefix}_TOGGLE_ALL_SELECTED`,
  CLEAR_ALL_SELECTED: `${prefix}_CLEAR_ALL_SELECTED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  doClearAllSelected() {
    return {
      type: notificacionListActions.CLEAR_ALL_SELECTED,
    };
  },

  doToggleAllSelected() {
    return {
      type: notificacionListActions.TOGGLE_ALL_SELECTED,
    };
  },

  doToggleOneSelected(id) {
    return {
      type: notificacionListActions.TOGGLE_ONE_SELECTED,
      payload: id,
    };
  },

  doReset: () => async (dispatch) => {
    dispatch({
      type: notificacionListActions.RESETED,
    });

    dispatch(notificacionListActions.doFetch());
  },

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: notificacionListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await NotificacionService.list(
        filter,
        selectors.selectOrderBy(getState()),
        null,
        null,
      );

      new Exporter(
        exporterFields,
        i18n('entities.notificacion.exporterFileName'),
      ).transformAndExportAsExcelFile(response.rows);

      dispatch({
        type: notificacionListActions.EXPORT_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: notificacionListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePagination:
    (pagination) => async (dispatch, getState) => {
      dispatch({
        type: notificacionListActions.PAGINATION_CHANGED,
        payload: pagination,
      });

      dispatch(
        notificacionListActions.doFetchCurrentFilter(),
      );
    },

  doChangeSort: (sorter) => async (dispatch, getState) => {
    dispatch({
      type: notificacionListActions.SORTER_CHANGED,
      payload: sorter,
    });

    dispatch(
      notificacionListActions.doFetchCurrentFilter(),
    );
  },

  doFetchCurrentFilter:
    () => async (dispatch, getState) => {
      const filter = selectors.selectFilter(getState());
      const rawFilter = selectors.selectRawFilter(
        getState(),
      );
      dispatch(
        notificacionListActions.doFetch(
          filter,
          rawFilter,
          true,
        ),
      );
    },

  doFetch:
    (filter?, rawFilter?, keepPagination = false) =>
    async (dispatch, getState) => {
      try {
        if((!filter.estado && !filter.estado_nin) || filter.estado === 'Entrada') filter.estado_nin = ['Archivada','Eliminada'];
        dispatch({
          type: notificacionListActions.FETCH_STARTED,
          payload: { filter, rawFilter, keepPagination },
        });

        const response = await NotificacionService.list(
          filter,
          selectors.selectOrderBy(getState()),
          selectors.selectLimit(getState()),
          selectors.selectOffset(getState()),
        );

        dispatch({
          type: notificacionListActions.FETCH_SUCCESS,
          payload: {
            rows: response.rows,
            count: response.count,
            countMultiWay: response.countMultiWay,
            countSinLeer: response.countSinLeer,
            countEntradas: response.countEntradas,
            countFavoritas: response.countFavoritas,
            countArchivadas: response.countArchivadas,
            countEliminadas: response.countEliminadas,
            countImportantes: response.countImportantes,
            countTareas: response.countTareas,
            countFirmas: response.countFirmas,
          },
        });
      } catch (error) {
        Errors.handle(error);

        dispatch({
          type: notificacionListActions.FETCH_ERROR,
        });
      }
    },
};

export default notificacionListActions;
